import { render } from "./LoadsView.vue?vue&type=template&id=6eff04e2&scoped=true"
import script from "./LoadsView.vue?vue&type=script&lang=js"
export * from "./LoadsView.vue?vue&type=script&lang=js"

import "./LoadsView.vue?vue&type=style&index=0&id=6eff04e2&lang=scss&scoped=true"

import exportComponent from "/workspace/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6eff04e2"]])

export default __exports__